module.exports = __webpack_public_path__ + "img/day-pass.641cc398.webp";